<template>
  <div class="lock-page">
    <app-navbar></app-navbar>
    <div class="wrapper wrapper-full-page">
      <div class="full-page lock-page section-image" filter-color="black">
        <!--   you can change the color of the filter page using: data-color="blue | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">
              <card v-if="showLogin" type="lock" class="text-center">
                <img
                  slot="header"
                  src="static/img/central-gym150x150.webp"
                  alt="CentralGym logo"
                />
                <h4 class="card-title">DailyPass Validator</h4>
                <h6 class="card-subtitle mb-2 text-muted">
                  incia sesión para comenzar...
                </h6>
                <small>(Realizar login de socios)</small>
                <fg-input
                  type="email"
                  placeholder="email ..."
                  v-model="form.email"
                ></fg-input>
                <fg-input
                  type="password"
                  placeholder="Contraseña ..."
                  v-model="form.password"
                ></fg-input>
                <p-button
                  @click="submit"
                  slot="footer"
                  type="default"
                  round
                  outline
                >
                  Iniciar sesión
                </p-button>
              </card>
              <card v-if="showValidator" type="lock" class="text-center">
                <img
                  slot="header"
                  src="static/img/central-gym150x150.webp"
                  alt="CentralGym logo"
                />
                <h4 class="card-title">DailyPass Validator</h4>
                <h6 class="card-subtitle mb-2 text-muted">
                  ingresa tu rut y pase diario...
                </h6>
                <small>(sólo valida contra membresias de socios_plan_principal y sólo necesita rut)</small>
                <fg-input
                  type="email"
                  placeholder="rut ..."
                  v-model="form.nid"
                ></fg-input>
                <fg-input
                  type="password"
                  placeholder="N° de transacción ..."
                  v-model="form.trx"
                ></fg-input>
                <p>Data resultante</p>
                <p v-if="QRData">{{ QRData }}</p>
                <p-button
                  @click="validatePass"
                  slot="footer"
                  type="default"
                  round
                  outline
                >
                  Validar Acceso
                </p-button>
              </card>
            </div>
          </div>
        </div>
        <app-footer></app-footer>
        <div
          class="full-page-background"
          style="background-image: url(static/img/background/bruno-abatti.jpg)"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import AppNavbar from "./Layout/AppNavbar";
import AppFooter from "./Layout/AppFooter";
import { Card, Button, FgInput } from "src/components/UIComponents";
import axios from "axios";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";

export default {
  components: {
    Card,
    AppNavbar,
    AppFooter,
    FgInput,
    [Button.name]: Button,
  },
  data() {
    return {
      form: {
        email: "",
        password: "",
        nid: "",
        trx: "",
      },
      username: sessionStorage.getItem("WHbUjdv3TG") || "No User",
      email: sessionStorage.getItem("email") || "No Email",
      showLogin: true,
      showValidator: false,
      QRData: ""
    };
  },
  methods: {
    showSwal(mensajeServicio, CodigoHTTP) {
      new swal({
        title: `ERROR: ${CodigoHTTP}`,
        text: mensajeServicio,
        buttonsStyling: false,
        confirmButtonClass: "btn btn-success btn-fill",
      });
    },
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      document.body.classList.remove("off-canvas-sidebar");
    },
    async submit() {
      // let userDataToJSON = JSON.parse(sessionStorage.getItem("username"));
      // let userSession = userDataToJSON.usuarioSesion;
      let userSession = sessionStorage.getItem("WHbUjdv3TG");
      // console.log(userSession);

      await this.$MasterControlAPI
        .post("/v2/user/auth/login", {
          Header: {
            Operacion: this.$Operations.Login,
          },
          Body: {
            user: this.form.email,
            password: this.form.password,
          },
        })
        .then((result) => {
          let response = result.data.Response;
          console.log(response);
          if (
            response.Resultado.CodigoHTTP === 200 ||
            response.Resultado.CodigoHTTP === 201
          ) {
            console.log(response);
            sessionStorage.setItem("jCxbraoQeD", response.Auth.Token)
            this.showLogin = false
            this.showValidator = true
          } else {
            console.log("ERROR");
          }
        })
        .catch((err) => {
          let mensajeServicio =
            err.response.data.Response.Resultado.MensajeServicio;
          let CodigoHTTP = err.response.data.Response.Resultado.CodigoHTTP;
          this.showSwal(mensajeServicio, CodigoHTTP);
        });
    },
    async validatePass() {
      // let userDataToJSON = JSON.parse(sessionStorage.getItem("username"));
      // let userSession = userDataToJSON.usuarioSesion;
      // console.log(userSession);

      await this.$MasterControlAPI
        .post("/v2/socios/validarAcceso", {
          Header: {
            Operacion: this.$Operations.Login,
          },
          Auth: { Token: sessionStorage.getItem("jCxbraoQeD") },
          Parameters: {
            rut: this.form.nid,
            mobile: true,
            trx: this.form.trx,
          },
          Body: {
            metodoAcceso: "APLICACION MOBILE",
            detalleMetodoAcceso: "Pago ON-LINE",
            fechaHoraIngreso: "26-02-2024 20:33:03",
            idAcceso: "2TEC-DEVICE-0",
          },
        })
        .then((result) => {
          let response = result.data.Response;
          this.QRData = response.DataOut
        })
        .catch((err) => {
          let mensajeServicio =
            err.response.data.Response.Resultado.MensajeServicio;
          let CodigoHTTP = err.response.data.Response.Resultado.CodigoHTTP;
          this.showSwal(mensajeServicio, CodigoHTTP);
        });
    },
  },

  beforeCreate() {},
  beforeDestroy() {
    this.closeMenu();
  },
};
</script>
<style></style>
